import React, { useEffect, useState } from 'react'
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap'
import { useEscuela } from 'hooks/useEscuela'

// @constantes
import { CAMPOS_PROGRAMA, LABELS_PROGRAMA, LIMITE_CARACTERES_ACDP, MAXIMO_NUMERO_DE_PERIODOS } from './constantes'

export const ProgramaEscuela = ({
  navigation,
  programaAcademico,
  actualizarProgramaAcademico
}) => {
  /**
   * Consultas
   */
  const {
    obtenerEscuelas
  } = useEscuela()
  const { data: escuelas } = obtenerEscuelas()

  /** 
   * Stados
  */
  const [desabilitarBotonSiguiente, setDesabilitarBotonSiguiente] = useState(true)

  /**
   * Efectos
   */
  useEffect(() => {
    const campoSinLlenar =
      !programaAcademico[CAMPOS_PROGRAMA.ESCUELA]
      || !programaAcademico[CAMPOS_PROGRAMA.NIVEL_FORMACION]
      || !programaAcademico[CAMPOS_PROGRAMA.PERIODOS]
      || !programaAcademico[CAMPOS_PROGRAMA.NOMBRE_PROGRAMA_ACADEMICO]
      || !programaAcademico[CAMPOS_PROGRAMA.MODALIDAD]
      || !programaAcademico[CAMPOS_PROGRAMA.CREDITOS]
      || !programaAcademico[CAMPOS_PROGRAMA.CODIGO_SNIES]
      || !programaAcademico[CAMPOS_PROGRAMA.ACUERDO_CREACION_PROGRAMA]
    
    setDesabilitarBotonSiguiente(campoSinLlenar)
  }, [programaAcademico])
  

  /**
   * Manejadores
   */
  const manejadorDeCambios = (campo, valor) => {
    actualizarProgramaAcademico(estadoPrevio => ({
      ...estadoPrevio,
      [campo]: valor
    }))
  }

  const manejadorEscuela = ({ target: { value } }) => 
    manejadorDeCambios(CAMPOS_PROGRAMA.ESCUELA, value)

  const manejadorNivelFormacion = ({ target: { value } }) => 
    manejadorDeCambios(CAMPOS_PROGRAMA.NIVEL_FORMACION, value)
  

  const manejadorPeriodos = ({ target: { value } }) => {
    const parsedValue = parseInt(value);
    if (parsedValue < 1 || parsedValue > MAXIMO_NUMERO_DE_PERIODOS) {
      return
    }
    manejadorDeCambios(CAMPOS_PROGRAMA.PERIODOS, value)
  }

  const manejadorNombreProgramaAcademico = ({ target: { value } }) => 
    manejadorDeCambios(CAMPOS_PROGRAMA.NOMBRE_PROGRAMA_ACADEMICO, value)
  
  const manejadorModalidad = ({ target: { value } }) => 
    manejadorDeCambios(CAMPOS_PROGRAMA.MODALIDAD, value)
  
  const manejadorCreditos = ({ target: { value } }) => {
    const parsedValue = parseInt(value);
    if (parsedValue < 0) {
      return
    }
    manejadorDeCambios(CAMPOS_PROGRAMA.CREDITOS, value)
  }

  const manejadorCodigoSnies = ({ target: { value } }) => {
    const parsedValue = parseInt(value);
    if (parsedValue < 0) {
      return
    }
    manejadorDeCambios(CAMPOS_PROGRAMA.CODIGO_SNIES, value)
  }
  
  const manejadorAcuerdoCreacionPrograma = ({ target: { value } }) => {
    if (value.length > LIMITE_CARACTERES_ACDP) {
      return 
    }
    manejadorDeCambios(CAMPOS_PROGRAMA.ACUERDO_CREACION_PROGRAMA, value)
  }
  
  const manejadorProgramaAcreditado = ({ target: {checked: value} }) => {
    manejadorDeCambios(CAMPOS_PROGRAMA.PROGRAMA_ACREDITADO, value)
  }

  const manejadorBotonSiguiente = () => {
    navigation.next()
  }
  
  return (
    <div className='container'>
      <div>
        <Form>
          <Row form>
            <Col md={5}>
              <FormGroup>
                <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.ESCUELA]} *</Label>
                <Input type='select'
                  onChange={manejadorEscuela}
                  value={programaAcademico[CAMPOS_PROGRAMA.ESCUELA] || ''}
                >
                  <option value={null} >Selecione...</option>
                  {escuelas?.results?.map(({ id, nombre }) =>
                    <option key={id} value={id}>{nombre}</option>)
                  }
                </Input>
              </FormGroup>
            </Col>
            <Col md={5}>
              <FormGroup>
                <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.NIVEL_FORMACION]} *</Label>
                <Input
                  type='select'
                  onChange={manejadorNivelFormacion}
                  value={programaAcademico[CAMPOS_PROGRAMA.NIVEL_FORMACION] || ''}
                >
                  <option value={null}>Selecione...</option>
                  <option>Tecnológico</option>
                  <option>Profesional</option>
                  <option>Especialización</option>
                  <option>Maestría</option>
                  <option>Doctorado</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.PERIODOS]} *</Label>
                <Input
                  placeholder='...'
                  type='number'
                  onChange={manejadorPeriodos}
                  value={programaAcademico[CAMPOS_PROGRAMA.PERIODOS]}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md={5}>
              <FormGroup>
                <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.NOMBRE_PROGRAMA_ACADEMICO]} *</Label>
                <Input
                  placeholder='...'
                  type='text'
                  onChange={manejadorNombreProgramaAcademico}
                  value={programaAcademico[CAMPOS_PROGRAMA.NOMBRE_PROGRAMA_ACADEMICO] || ''}
                />
              </FormGroup>
            </Col>
            <Col md={5}>
              <FormGroup>
                <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.MODALIDAD]} *</Label>
                <Input
                  type='select'
                  onChange={manejadorModalidad}
                  value={programaAcademico[CAMPOS_PROGRAMA.MODALIDAD] || ''}
                >
                  <option value={null}>Selecione...</option>
                  <option>Distancia</option>
                  <option>Presencial</option>
                  <option>Dual</option>
                  <option>Virtual</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.CREDITOS]} *</Label>
                <Input
                  placeholder='...'
                  type='number'
                  onChange={manejadorCreditos}
                  value={programaAcademico[CAMPOS_PROGRAMA.CREDITOS]}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <Label check>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.ACUERDO_CREACION_PROGRAMA]} *</Label>
              <Input
                placeholder='...'
                type='textarea'
                onChange={manejadorAcuerdoCreacionPrograma}
                value={programaAcademico[CAMPOS_PROGRAMA.ACUERDO_CREACION_PROGRAMA] || ''}
              />
            </Col>
          </Row>

          <Row form>
            <Col md={2} className='mr-3 mt-3'>
              <FormGroup>
                <Label>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.CODIGO_SNIES]} *</Label>
                <Input
                  type='number'
                  placeholder='...'
                  onChange={manejadorCodigoSnies}
                  value={programaAcademico[CAMPOS_PROGRAMA.CODIGO_SNIES]}
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className='mt-5' check inline>
                <Input
                  type="checkbox"
                  onChange={manejadorProgramaAcreditado}
                  checked={programaAcademico[CAMPOS_PROGRAMA.PROGRAMA_ACREDITADO]}
                />
              <Label check>{LABELS_PROGRAMA[CAMPOS_PROGRAMA.PROGRAMA_ACREDITADO]}</Label>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </div>

      <div className='mt-3'>
        <Button
          variant='contained'
          color='primary'
          onClick={manejadorBotonSiguiente}
          disabled={desabilitarBotonSiguiente}
        >
          Siguiente
        </Button>
      </div>
    </div>
  )
}
